import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import TooltipsMixin from "@Shared/utils/shared-mixins/tooltips-mixin";
import MaterialInput from "@Shared/components/inputs/material-input";
import Select2 from "@Shared/components/inputs/select2";
import { mapActions, mapGetters } from "vuex";
import { GET_BOARD_STATUSES, SELECTED_BOARD } from "@Broker/@Modules/clients/board/store/board-getters";
import { LOAD_BOARD_CLIENTS, TRANSFER_BOARD_CLIENT_PROFILES } from "@Broker/@Modules/clients/board/store/board-actions";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import BoardSelect from "@Broker/@Modules/clients/board/client-board/components/boards-select.vue";
import { cloneDeep, debounce, isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SettingsColumn",
  components: {
    InlinePrompt,
    MaterialInput,
    Select2,
    SimpleButton,
    BoardSelect
  },
  mixins: [TooltipsMixin],
  props: {
    rottingDaysThreshold: {
      type: Number,
      required: true
    },
    muteAutomations: {
      type: Boolean,
      required: true
    },
    muteNotifications: {
      type: Boolean,
      required: true
    },
    firstColumnLabel: {
      type: String,
      default: ""
    },
    isFirstColumn: {
      type: Boolean,
      default: false
    },
    statusId: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      includeRottingDaysThreshold: this.rottingDaysThreshold > 0,
      rottingDaysThresholdLocal: this.rottingDaysThreshold,
      muteAutomationsLocal: this.muteAutomations,
      muteNotificationsLocal: this.muteNotifications,
      DIR_LEFT: -1,
      DIR_RIGHT: 1,
      toBoardId: null,
      toStatusLabelId: null,
      moveClients: {
        loading: false,
        succeeded: true
      },
      loadingStatuses: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [GET_BOARD_STATUSES, SELECTED_BOARD])), {}, {
    selectedToBoardStatuses() {
      var _context;
      return this.toBoardId ? _filterInstanceProperty(_context = _Object$values(this.GET_BOARD_STATUSES(this.toBoardId).byId || {})).call(_context, ({
        id
      }) => id !== this.statusId) // exclude current status
      : [];
    },
    disabledMove() {
      return !this.toBoardId || this.SELECTED_BOARD.id === this.toBoardId && !this.toStatusLabelId;
    },
    columnHaveClients() {
      return this.count > 0;
    }
  }),
  watch: {
    includeRottingDaysThreshold(val) {
      if (!val) {
        this.rottingDaysThresholdLocal = 0;
        return this.handleChange();
      }
      this.rottingDaysThresholdLocal = 1;
      this.handleChange();
      this.$nextTick(() => {
        this.$refs.rottingDaysInput.focus();
      });
    }
  },
  destroyed() {
    this.destroyTooltips();
  },
  mounted() {
    this.initTooltips();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARD_CLIENTS, TRANSFER_BOARD_CLIENT_PROFILES])), {}, {
    handleChange: debounce(function () {
      const rottingDaysThreshold = _parseInt(this.rottingDaysThresholdLocal);
      this.$emit("change", {
        rottingDaysThreshold,
        muteAutomations: this.muteAutomationsLocal,
        muteNotifications: this.muteNotificationsLocal
      });
    }, 100),
    handleMove(dir) {
      this.$emit("move", dir);
    },
    handleDelete() {
      this.$emit("delete");
    },
    formatData(data) {
      var _data$map, _data;
      data = cloneDeep(data);
      return (_data$map = (_data = data) == null ? void 0 : _mapInstanceProperty(_data).call(_data, ref => {
        var _ref$name;
        ref.value = ref.id;
        ref.text = (_ref$name = ref.name) != null ? _ref$name : ref.label;
        return ref;
      })) != null ? _data$map : [];
    },
    handleBoardChange({
      id
    }) {
      this.toBoardId = id;
      if (isEmpty(this.selectedToBoardStatuses)) this.loadStatuses();
    },
    handleStatusChange({
      id
    }) {
      this.toStatusLabelId = id;
    },
    async handleMoveClients() {
      try {
        this.moveClients.loading = true;
        await this.TRANSFER_BOARD_CLIENT_PROFILES({
          boardId: this.SELECTED_BOARD.id,
          currentStatusLabelId: this.statusId,
          toBoardId: this.toBoardId,
          toStatusLabelId: this.toStatusLabelId,
          count: this.count
        });
        this.moveClients.succeeded = true;
        this.toBoardId = null;
        this.toStatusLabelId = null;
      } catch (e) {
        this.moveClients.succeeded = false;
      } finally {
        this.moveClients.loading = false;
      }
    },
    async loadStatuses() {
      this.loadingStatuses = true;
      await this.LOAD_BOARD_CLIENTS({
        boardId: this.toBoardId
      });
      this.$root.$emit("bv::hide::tooltip", "statuses-select-tooltip");
      this.loadingStatuses = false;
    }
  })
});